import { getFormattedPrice } from "../../utils/creditUtils";
import classes from "./premiumPlanCards.module.css";
import cx from "classnames";
import CustomButtonWrapper from "../CustomButtonWrapper";
import useAllCrditSkusStore from "../../zustandStores/allCreditSkus";
import { useRouter } from "next/router";
import { Routes } from "../../routes/RouteConstants";
import { memo } from "react";
import { isEqual, isMobileDevice, isSaleActive } from "../../services/utils";
import useModalStore from "../../zustandStores/useModalStore";
import { useSelector } from "react-redux";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import DiscountPriceTag from "./DiscountPriceTag";
import SalesTag from "./SalesTag";

const PremiumPlanCards = props => {
  const router = useRouter();
  const storedProfile = useSelector(
    state => state.userProfileReducer.payload?.data
  );
  const { data } = useAllCrditSkusStore(
    state => ({
      data: state.data
    }),
    (previousState, currentState) => isEqual(previousState, currentState)
  );
  const { setModalData } = useModalStore(state => ({
    setModalData: state.setModalData
  }));
  const centeredClass = "flex justify-center";

  const handleBuyCta = item => {
    if (storedProfile?.denial_reason === "BLACKLIST") {
      LogService.log(CREDIT_EVENTS.BLACKLIST_REC_PURCHASE_POP_UP_SHOWN);
      setModalData({
        view: "CREDITS",
        state: "open",
        type: "blacklisted",
        onCloseButtonClick: () =>
          LogService.log(CREDIT_EVENTS.BLACKLIST_REC_PURCHASE_POP_UP_CLOSED)
      });
      return;
    }
    const queryParams = {};
    queryParams.skuId = item.skuId;
    const { quantity = 1 } = router.query;
    LogService.log(CREDIT_EVENTS.PLAN_SELECTION_BUY_CLICKED, {
      skuId: item.skuId,
      quantity: item.skuId === 1 ? quantity : undefined
    });
    if (item.maxQuantityAllowed > 1) {
      queryParams.quantity = quantity;
    }

    router.push({
      pathname: Routes.CHECKOUT,
      query: queryParams
    });
  };
  const isMobile = isMobileDevice();
  const isSaleLive = isSaleActive();
  return (
    <>
      <div className={classes.root}>
        {data
          .filter(item => item.skuId !== 5)
          .map(item => {
            return (
              <div
                key={`${item.skuId}`}
                className={cx(
                  classes.cardCnt,
                  item.recommended ? classes.recoCard : null
                )}
              >
                {item.recommended ? (
                  <img
                    src="/hire/recommended.svg"
                    alt="recommended"
                    className={cx(classes.recoTag, "hidden md:block")}
                  />
                ) : null}
                {item.recommended && !isSaleLive ? (
                  <img
                    src="/hire/reco_mobile.svg"
                    alt="recommended"
                    className={cx(classes.recoTag, "block md:hidden")}
                  />
                ) : null}
                {isSaleLive ? (
                  <SalesTag item={item} isMobile={isMobile} />
                ) : null}
                <div className="hidden md:block">
                  <div className={classes.premiumJobCount}>{item.label}</div>
                  <div
                    className={cx(
                      classes.creditCount,
                      `${centeredClass} items-center`
                    )}
                  >
                    {getFormattedPrice(item.credits)} Credits
                  </div>
                  <div
                    className={cx(
                      `${centeredClass} items-start`,
                      classes.pricingCnt
                    )}
                  >
                    <div className={classes.discountedPrice}>
                      ₹ &nbsp;{getFormattedPrice(item.discountedPrice)}
                    </div>
                    {item.discountPercentage ? (
                      <div className={classes.mrPrice}>
                        ₹ &nbsp;{getFormattedPrice(item.maximumRetailPrice)}
                      </div>
                    ) : null}
                  </div>
                  <DiscountPriceTag isSaleLive={isSaleLive} item={item} />

                  <div
                    className={cx(
                      classes.startNowBtnCnt,
                      centeredClass,
                      item.maxQuantityAllowed > 1
                        ? classes.marginForStepper
                        : null
                    )}
                  >
                    <CustomButtonWrapper
                      customClass={classes.startNowBtn}
                      content={"Buy Now"}
                      onClick={() => handleBuyCta(item)}
                      disableAfterClick={false}
                    />
                  </div>
                  <div
                    className={cx(classes.expiryCnt)}
                    dangerouslySetInnerHTML={{
                      __html: `${item.validity}`
                    }}
                  />
                </div>
                <div
                  className={`block md:hidden relative ${
                    isSaleLive ? "mt-4" : null
                  }`}
                >
                  <div className="flex justify-between">
                    <div className="flex flex-col">
                      <div className={classes.premiumJobCount}>
                        {item.label}
                      </div>
                      <div
                        className={cx(
                          classes.creditCount,
                          ` flex justify-start  md:justify-center  items-center`
                        )}
                      >
                        {`${getFormattedPrice(item.credits)} Credits`}
                      </div>

                      <div
                        className={cx(classes.expiryCnt, "block md:hidden")}
                        dangerouslySetInnerHTML={{
                          __html: `${item.validity}`
                        }}
                      />
                    </div>
                    <div className="flex justify-between flex-col">
                      <div className={classes.discountedPrice}>
                        ₹ &nbsp;{getFormattedPrice(item.discountedPrice)}
                      </div>
                      {item.discountPercentage ? (
                        <div className={classes.mrPrice}>
                          ₹ &nbsp;{getFormattedPrice(item.maximumRetailPrice)}
                        </div>
                      ) : null}
                      <div
                        className={cx(
                          classes.startNowBtnCnt,
                          centeredClass,
                          item.maxQuantityAllowed > 1
                            ? classes.marginForStepper
                            : null
                        )}
                      >
                        <CustomButtonWrapper
                          customClass={classes.startNowBtn}
                          content={"Buy Now"}
                          onClick={() => handleBuyCta(item)}
                          disableAfterClick={false}
                        />
                      </div>
                    </div>
                  </div>
                  {item.discountPercentage ? (
                    <DiscountPriceTag isSaleLive={isSaleLive} item={item} />
                  ) : null}
                </div>
              </div>
            );
          })}
      </div>
      <div className={cx(classes.taxesNote, centeredClass)}>
        Note - Taxes will be added as applicable.
      </div>
    </>
  );
};
export default memo(PremiumPlanCards);
